import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=a8076596"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports